
export const userFunctionRoles = [
    { key: "decisionMaker", text: 'Decision Maker' },
    { key: "student", text: 'Student' },
    { key: "bondHolder", text: 'Bond Holder' },
    { key: "teacher", text: 'teacher' }
];
